export default __webpack_public_path__ + "static/media/andes_a_la_costa_3.6173eef3.JPG";